module.exports = __webpack_public_path__ + "static/flags/LE-c963ae7a6fd714c4ebfb0ad5d8e48c59.gif";